import { ILicenseTypeSelection } from "components/licence/LicenseTypeProvider";
import moment from "moment";

export function calculateExpiryIso(licenceType: ILicenseTypeSelection | undefined): string | "LIFETIME" | undefined {
    if (!licenceType) {
        return undefined;
    }
    if (licenceType.isLifetime) {
        return "LIFETIME";
    }
    if (licenceType.expiryDate) {
        return moment(licenceType.expiryDate.calculatedExpiryDate).toISOString();
    }
    if (licenceType.expiryMonths) {
        return moment().add(licenceType.expiryMonths, "months").toISOString();
    }
    return moment().toISOString();
}
